import { addNavMenuItem, addNavMenuSection } from "@bb-vendure/admin-ui/core";

export default [
  
  

  // addNavMenuItem(
  //   {
  //     id: "shippable",
  //     label: "Shippable",
  //     icon: "bundle",
  //     routerLink: ["/extensions/shippable"],
  //   },
  //   "need-to-ship-section"
  // ),
  // addNavMenuItem(
  //   {
  //     id: "shippable-approve",
  //     label: "Shippable approve",
  //     icon: "bundle",
  //     routerLink: ["/extensions/shippable-approve"],
  //   },
  //   "need-to-ship-section"
  // ),
];
